import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export const LOGIN_PATH = '/login';
export const REGISTER_PATH = '/register';
export const PRIVACY_POLICY_PATH = '/privacyPolicy';
export const COOKIE_POLICY_PATH = '/cookiePolicy';

export const PUBLIC_APP_TAB_PATHS = [
    LOGIN_PATH,
    REGISTER_PATH,
    '/ConfirmEmail',
    '/passwordreset',
    '/requestpassword',
    PRIVACY_POLICY_PATH,
    COOKIE_POLICY_PATH,
];

const legalLinks = [
    { label: 'Privacy Policy', path: PRIVACY_POLICY_PATH },
    { label: 'Cookie Policy', path: COOKIE_POLICY_PATH }
];

const LegalLinks = ({ align = 'center', color = 'textSecondary', onClick }) => (
    <Box sx={{ display: 'flex', justifyContent: align, gap: 1, flexWrap: 'wrap' }}>
        {legalLinks.map((item, index) => (
            <React.Fragment key={item.path}>
                <Link component={RouterLink} to={item.path} variant="body2" color={color} onClick={onClick}>
                    {item.label}
                </Link>
                {index < legalLinks.length - 1 && (
                    <Typography variant="body2" color={color}>
                        |
                    </Typography>
                )}
            </React.Fragment>
        ))}
    </Box>
);

export { legalLinks };
export default LegalLinks;
